import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import envConfig from '../../config';
import {
  fetchEmailsForThread,
  fetchLinkedEntitiesForThread,
  updateThreadByLinkingEntities,
  updateThreadByStatus,
} from '../routines/emailRoutines';
import { request } from '../../common/util/RestClient';
import { fetchIntegrations } from '../routines/integrations/integrationDataRoutines';
import { showWarningMessage } from '../routines/notificationRoutines';
import {
  EMAIL_STATUS,
  REVOKE_EMAIL_WARNING,
} from '../../common/constants/EmailConstants';
import { fetchEmail } from '../routines';
import {
  CALENDAR_STATUS,
  REVOKE_CALENDAR_WARNING,
  REVOKE_GOOGLE_WARNING,
} from '../../common/constants/GoogleConstants';
import { INTEGRATION_TYPE } from '../../common/constants/IntegrationConstants';

function* fetchEmailsForThreadSaga(action) {
  const { threadId } = action.payload;

  try {
    const url = `${envConfig.APIG_URL}email-v3/threads/${threadId}/messages`;

    const response = yield call(request, url);

    yield put(fetchEmailsForThread.success({ threadId, response }));
  } catch (error) {
    const noAlert = error.response.data.data?.message === 'Not Found';

    yield put(fetchEmailsForThread.failure({ threadId, error, noAlert }));
  }
}

function* fetchGoogleRevokeStatusSaga({ payload }) {
  const { user } = payload;
  const isCalendarAccessRevoked = user?.some(
    ({ status, type }) =>
      status === CALENDAR_STATUS.REVOKED && type === INTEGRATION_TYPE.SCHEDULING
  );
  const isGmailAccessRevoked = user?.some(
    ({ status, type }) =>
      status === EMAIL_STATUS.REVOKED && type === INTEGRATION_TYPE.COMMUNICATION
  );

  if (isCalendarAccessRevoked && isGmailAccessRevoked) {
    yield put(
      showWarningMessage.success({
        warningMessage: true,
        message: REVOKE_GOOGLE_WARNING,
      })
    );
  } else if (isCalendarAccessRevoked) {
    yield put(
      showWarningMessage.success({
        warningMessage: true,
        message: REVOKE_CALENDAR_WARNING,
      })
    );
  } else if (isGmailAccessRevoked) {
    yield put(
      showWarningMessage.success({
        warningMessage: true,
        message: REVOKE_EMAIL_WARNING,
      })
    );
  } else {
    yield put(
      showWarningMessage.success({
        warningMessage: false,
      })
    );
  }
}

function* fetchEmailLinkedEntitiesSaga(action) {
  const { threadId } = action.payload;

  try {
    const url = `${envConfig.APIG_URL}email-v3/threads/${threadId}`;

    const response = yield call(request, url);

    yield put(fetchLinkedEntitiesForThread.success({ threadId, response }));
  } catch (error) {
    const noAlert = error.response.data.data?.message === 'Not Found';

    yield put(
      fetchLinkedEntitiesForThread.failure({ threadId, error, noAlert })
    );
  }
}

function* updateThreadByStatusSaga({ payload }) {
  const { formData, level, entityId, threadId, filters } = payload;

  try {
    const URL = `${envConfig.APIG_URL}email-v3/threads/${threadId}/status`;
    const config = {
      method: 'PATCH',
      payload: formData,
    };
    const response = yield call(request, URL, config);
    yield put(updateThreadByStatus.success(response));
    yield put(fetchEmail({ level, entityId, filters }));
  } catch (err) {
    yield put(updateThreadByStatus.failure({ error: err }));
  }
}

function* updateThreadByLinkingEntitiesSaga({ payload }) {
  const { formData, level, entityId, threadId, filters } = payload;

  try {
    const URL = `${envConfig.APIG_URL}email-v3/threads/${threadId}/linking`;
    const config = {
      method: 'PATCH',
      payload: formData,
    };
    const response = yield call(request, URL, config);
    yield put(updateThreadByLinkingEntities.success(response));
    yield put(fetchEmail({ level, entityId, filters }));
  } catch (err) {
    yield put(updateThreadByLinkingEntities.failure({ error: err }));
  }
}

export default function* root() {
  yield all([takeEvery(fetchEmailsForThread, fetchEmailsForThreadSaga)]);
  yield all([
    takeLatest(fetchIntegrations.SUCCESS, fetchGoogleRevokeStatusSaga),
  ]);
  yield all([
    takeLatest(updateThreadByStatus.TRIGGER, updateThreadByStatusSaga),
  ]);
  yield all([
    takeLatest(
      updateThreadByLinkingEntities.TRIGGER,
      updateThreadByLinkingEntitiesSaga
    ),
  ]);
  yield all([
    takeLatest(
      fetchLinkedEntitiesForThread.TRIGGER,
      fetchEmailLinkedEntitiesSaga
    ),
  ]);
}
